import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formattaNumero'
})
export class FormattaNumeroPipe implements PipeTransform {

  transform(value: number): string {
    if (!value && value !== 0) return '';
    
    // Formatta il numero con il separatore delle migliaia e la virgola per i decimali
    return value.toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

}
